import Vue from 'vue'
import VueRouter from 'vue-router'
import login from '../components/login.vue'
import index from '../components/index.vue'
import error_404 from '../components/error_404.vue'
import home from '../components/home.vue'
import storeList from '../components/storeList.vue'
import storeListUnAuth from '../components/storeListUnAuth.vue'
import storeInfo from '../components/storeInfo.vue'
import addStore from '../components/addStore.vue'
import payFinish from '../components/payFinish.vue'
import payList from '../components/payList.vue'
import freezeList from '../components/freezeList.vue'
import freezeing from '../components/freezeing.vue'
import tixianshenqing from '../components/tixianshenqing.vue'
import tixianjilu from '../components/tixianjilu.vue'
import freezeInfo from '../components/freezeInfo.vue'
import fankuijianyi from '../components/fankuijianyi.vue'
import changjianwenti from '../components/changjianwenti.vue'
import tianjiazhanghao from '../components/tianjiazhanghao.vue'
import admin_info from '../components/admin_info.vue'
import jiankangshenbaojiankong from '../components/jiankangshenbaojiankong.vue'
import zhanghaoguanli from '../components/zhanghaoguanli.vue'
import juesequanxian from '../components/juesequanxian.vue'
import error_504 from '../components/error_504.vue'
import employeManage from '../components/employeManage.vue'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	console.log(this);
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

export default new VueRouter({
	mode: 'history',
	routes: [{
		path: '/',
		name: '首页',
		component: index,
		children: [{
			path: 'home',
			name: '统计',
			component: home
		},{
			path:'storeList',
			name:'已认证门店',
			component: storeList
		},{
			path:'storeListUnAuth',
			name:'待认证门店',
			component: storeListUnAuth
		},{
			path:'storeInfo',
			name:'门店详情',
			component: storeInfo
		},{
			path:'addStore',
			name:'添加门店',
			component: addStore
		},{
			path:'payFinish',
			name:'扣款申请',
			component: payFinish
		},{
			path:'payList',
			name:'扣款记录',
			component: payList
		},{
			path:'freezeList',
			name:'授权记录',
			component: freezeList
		},{
			path:'freezeing',
			name:'进行中授权',
			component: freezeing
		},
		{
			path:'tixianshenqing',
			name:'提现申请',
			component: tixianshenqing
		},{
			path:'tixianjilu',
			name:'提现记录',
			component: tixianjilu
		},{
			path:'fankuijianyi',
			name:'反馈建议',
			component: fankuijianyi
		},
		{
			path:'changjianwenti',
			name:'常见问题',
			component: changjianwenti
		},
		{
			path:'zhanghaoguanli',
			name:'账号管理',
			component: zhanghaoguanli
		},{
			path:'tianjiazhanghao',
			name:'添加账号',
			component: tianjiazhanghao
		},
		{
			path:'admin_info',
			name:'个人中心',
			component: admin_info
		},
		{
			path:'freezeInfo',
			name:'授权详情',
			component: freezeInfo
		},
		{
			path:'employeManage',
			name:'账号管理',
			component: employeManage
		}]
	}, {
		path: '/login',
		name: '登陆',
		component: login
	},{
		path: '/error_504',
		name: '服务器未响应',
		component: error_504
	}, {
		path: '*',
		name: '错误页面',
		component: error_404
	}]
})



// WEBPACK FOOTER //
// ./src/router/index.js